import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const TabButton = ({ icon = null, children, active = false, onClick = () => {}, className, ...buttonProps }) => {
    return (
        <StyledButton className={className} $active={active} onClick={onClick} {...buttonProps}>
            {icon}
            {children}
        </StyledButton>
    );
};

const StyledButton = styled.button`
  flex: 1;
  padding: ${({ theme }) => theme?.spacing?.small || '0.625rem'};
  border: none;
  background: ${({ $active }) => ($active ? '#fff' : 'transparent')};
  border-bottom: ${({ $active, theme }) =>
    $active ? `4px solid ${theme?.colors?.brand || 'rgba(130, 22, 146, 1)'}` : 'none'};
  color: ${({ $active, theme }) =>
    ($active ? theme?.colors?.brand || 'rgba(130, 22, 146, 1)' : theme?.colors?.textPrimary || '#333')};
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  &:hover {
    color: ${({ theme }) => theme?.colors?.brand || 'rgba(130, 22, 146, 1)'};
  }

  .icon {
    font-size: 1.2rem; /* Consistent icon size */
  }

  @media (max-width: ${({ theme }) => theme?.breakpoints?.mobile || '768px'}) {
    padding: 0.5rem;
    font-size: ${({ theme }) => theme?.fontSizes?.small || '0.9rem'};
    .icon {
      font-size: 1rem; /* Smaller icon on mobile */
    }
  }
`;

TabButton.propTypes = {
    icon: PropTypes.node, // Icon as a React element (optional)
    children: PropTypes.node.isRequired, // Tab title
    active: PropTypes.bool, // Whether the tab is active
    onClick: PropTypes.func, // Click handler
    className: PropTypes.string,
};

export default TabButton;
